/**
 * @namespace diffusion.clients
 */

/**
 * Enum containing standard session property keys
 *
 * @example
 * // Get the ALL_FIXED_PROPERTIES key
 * var props = diffusion.clients.PropertyKeys.ALL_FIXED_PROPERTIES;
 *
 * @example
 * // Get all user and fixed properties
 * var props = diffusion.clients.PropertyKeys.ALL_FIXED_PROPERTIES
 *      .concat(diffusion.clients.PropertyKeys.ALL_USER_PROPERTIES);
 *
 * @readonly
 * @enum
 * @memberOf diffusion.clients
 * @alias PropertyKeys
 */
var GetSessionPropertiesKeys = {
    /**
     * This constant can be used instead of a property key in requests for
     * session property values to indicate that <b>all</b> fixed session
     * properties are required. */
    ALL_FIXED_PROPERTIES: ['*F'],
    /**
     * This constant can be used instead of a property key in requests for
     * session property values to indicate that <b>all</b> user defined session
     * properties are required. */
    ALL_USER_PROPERTIES: ['*U'],
    /**
     * This constant can be used instead of a property key in requests for
     * session property values to indicate that <b>all</b> session
     * properties are required. */
    ALL_PROPERTIES: ['*F', '*U']
};

module.exports = {
    PropertyKeys: GetSessionPropertiesKeys
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/features/client-control-options.js
// module id = 273
// module chunks = 1